import React from 'react';
import ABSSelect from '../../../ABSSelect';
import { IYearRangePickerProps } from '../../interface';
import { getFromYearData, getToYearData } from '../../utils';
import RangePickerHelper from '../../helper/rangePickerHelper';

class YearRangePicker extends React.Component<IYearRangePickerProps, {}> {
  static defaultProps = {
    startPlaceholder: '请输入开始年份',
    endPlaceholder: '请输入结束年份',
    closeEqual: false
  };

  state = {
    startYear: this.props.startDefaultValue,
    endYear: this.props.endDefaultValue
  };

  private pickerHelper: RangePickerHelper = new RangePickerHelper();

  render() {
    const {
      startPlaceholder,
      endPlaceholder,
      startTitle,
      endTitle,
      required,
      maxEndYear,
      maxStartYear,
      closeEqual,
      removeMarginBottom,
      removePaddingLeft,
      isVertical,
      contentWidth,
      isFlex
    } = this.props;

    const { startYear, endYear } = this.state;
    const fromYearData = getFromYearData({
      end: endYear,
      maxStartYear,
      closeEqual
    });
    const toYearData = getToYearData({
      start: startYear,
      maxEndYear,
      closeEqual
    });
    return (
      <>
        <ABSSelect
          title={startTitle}
          selectOptions={fromYearData}
          required={required}
          value={startYear}
          placeholder={startPlaceholder}
          ref={view => (this.pickerHelper.startPickerRef = view)}
          onChange={this.onStartYearChange}
          removePaddingLeft={removePaddingLeft}
          isVertical={isVertical}
          contentWidth={contentWidth}
          isFlex={isFlex}
        />
        <ABSSelect
          title={endTitle}
          selectOptions={toYearData}
          required={required}
          value={endYear}
          placeholder={endPlaceholder}
          ref={view => (this.pickerHelper.endPickerRef = view)}
          onChange={this.onEndYearChange}
          removePaddingLeft={removePaddingLeft}
          removeMarginBottom={removeMarginBottom}
          isVertical={isVertical}
          contentWidth={contentWidth}
          isFlex={isFlex}
        />
      </>
    );
  }

  onStartYearChange = year => {
    this.setState({
      startYear: year
    }, () => {
      this.pickerHelper.startPickerRef.validatorValue();
    });
    const { onStartChange } = this.props;
    if (onStartChange) {
      onStartChange(year);
    }
  };

  onEndYearChange = year => {
    this.setState({
      endYear: year
    }, () => {
      this.pickerHelper.endPickerRef.validatorValue();
    });
    const { onEndChange } = this.props;
    if (onEndChange) {
      onEndChange(year);
    }
  };

  /**
   * ref
   */

  validatorValue = () => this.pickerHelper.validatorValue();

  reset = () => {
    const { startDefaultValue, endDefaultValue } = this.props;
    const newStartValue = startDefaultValue === undefined || startDefaultValue === null ? '' : startDefaultValue;
    const newEndValue = endDefaultValue === undefined || endDefaultValue === null ? '' : endDefaultValue;
    this.setState({ startValue: newStartValue, endValue: newEndValue}, () => {
      this.pickerHelper.resetResult();
    });
  };

  resetResult = () => {
    this.pickerHelper.resetResult();
  }

  getValue = () => {
    const { startYear, endYear } = this.state;
    return {
      start: startYear,
      end: endYear
    };
  };
}

export { IYearRangePickerProps };

export default YearRangePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/RangePicker/YearRangePicker/index.tsx